import {selectedPortals} from './portal-math.mjs';
const at=(worlds,id)=>worlds instanceof Map?worlds.get(id):worlds?.[id];
// Every known destination uses completed scene preparation, including primitives.
// Keep the existing unknown-definition behavior; pair resolution remains separate.
export function isModelDestinationReady(id,worlds,isReady){
  return !at(worlds,id)||isReady(id);
}
export function blockedModelPortalWorldIds(world,worlds,isReady,activePortalId){
  return [...new Set(selectedPortals(world,activePortalId).map(portal=>portal.targetWorldId).filter(id=>!isModelDestinationReady(id,worlds,isReady)))].slice(0,16);
}

